import { Route } from '@angular/router';
import { bookinghubRoutes } from '@beautyapp/bookinghub';

export const appRoutes: Route[] = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () =>
      import('./pages/portal/portal.component').then((m) => m.PortalComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@beautyapp/layout').then((m) => m.MainComponent),
        canActivate: [() => import('@beautyapp/auth').then((m) => m.AuthGuard)],
        children: [
          {
            path: 'dashboard',
            loadComponent: () =>
              import(
                '@beautyapp/dashboard/components/dashboard/dashboard.component'
              ).then((m) => m.DashboardComponent),
          },
          {
            path: 'cashier',
            loadChildren: () =>
              import('@beautyapp/cashier').then((m) => m.CashierModule),
          },
          {
            path: 'customers',
            loadChildren: () =>
              import('@beautyapp/users').then((m) => m.UsersModule),
          },
          {
            path: 'hr',
            loadChildren: () => import('@beautyapp/hr').then((m) => m.HrModule),
          },
          {
            path: 'transactions',
            loadChildren: () =>
              import('@beautyapp/transaction').then((m) => m.TransactionModule),
          },
          {
            path: 'services',
            loadChildren: () =>
              import('@beautyapp/service').then((m) => m.ServiceModule),
          },
          {
            path: 'calendars',
            loadChildren: () =>
              import('@beautyapp/appointment').then((m) => m.appointmentRoutes),
          },
          {
            path: 'expense',
            loadChildren: () =>
              import('@beautyapp/expense').then((m) => m.ExpenseModule),
          },
          {
            path: 'reports',
            loadChildren: () =>
              import('@beautyapp/reports').then((m) => m.ReportsModule),
          },
          {
            path: 'profile',
            loadChildren: () =>
              import('@beautyapp/profile').then((m) => m.ProfileModule),
          },
          {
            path: 'consignations',
            loadChildren: () =>
              import('@beautyapp/consignation').then(
                (m) => m.ConsignationModule
              ),
          },
          {
            path: 'operations',
            loadChildren: () =>
              import('@beautyapp/operation').then((m) => m.OperationModule),
          },
          {
            path: 'marketing',
            loadChildren: () =>
              import('@beautyapp/marketing').then((m) => m.MarketingModule),
          },
          {
            path: 'bookinghub',
            loadChildren: () =>
              import('@beautyapp/bookinghub').then((m) => m.bookinghubRoutes),
          },
          {
            path: 'ehealth',
            loadChildren: () =>
              import('@beautyapp/ehealth').then((m) => m.ehealthRoutes),
          },
          {
            path: 'service-packages',
            loadChildren: () =>
              import('@beautyapp/service-packages').then(
                (m) => m.servicePackagesRoutes
              ),
          },
          {
            path: 'warehouse',
            loadChildren: () =>
              import('@beautyapp/warehouse').then((m) => m.WarehouseModule),
          },
        ],
      },
      {
        path: 'admin',
        loadComponent: () =>
          import('@beautyapp/layout').then((m) => m.AdminLayoutComponent),
        loadChildren: () =>
          import('@beautyapp/admin').then((m) => m.adminRoutes),
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('@beautyapp/auth').then((m) => m.AuthModule),
  },
  {
    path: 'verify-agreement/:agreementId',
    loadComponent: () =>
      import('./pages/verify-agreement/verify-agreement.component').then(
        (m) => m.VerifyAgreementComponent
      ),
  },
  {
    path: 'verify/:termId',
    loadComponent: () =>
      import('./pages/verify/verify.component').then((m) => m.VerifyComponent),
  },
  {
    path: 'pad-sign/:agreementId',
    loadComponent: () =>
      import('./pages/pad-sign/pad-sign.component').then(
        (m) => m.PadSignComponent
      ),
  },
];
